import { filter } from "lodash";
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { codeMasterType } from "../../../config/constants";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import MultiSelectComponent from '../../../components/multi-select/multi-select.component';
import scheduleModel from "../../../models/schedule/jpo-schedule.model";
import ViewBase from "../../view-base.view";
import UnplannedStoreDialog from "./unplanned-store.dialog";
import { Tooltip, PopoverPosition } from "construct-ui";
import 'CssFolder/schedule/jpo/jpo-report.scss';

export default function PlanActualSummary() {
    ViewBase.call(this)

    let imceTypeList = [];
    let userRoleList = [];
    let adminList = [];
    let userRoleListByFilter = [];
    let supervisorList = [];
    let supervisorListByFilter = [];
    let displayPercentageList = [];
    let tableData = [];
    let imceTypeOld = '';
    let initLoadData = false;
    let isAdmin = 0;
    let isSubsidiaryAdmin = 0;
    let isDialogOpen = false;
    let unplannedStoreUserId = '';
    let scheduleSourceList = [    
        { code: "1", name: "JPO" },
        { code: "2", name: "Manual" },
    ]

    const DEFAULT_PAGINATION = {
        pageSize: 100,
        pageIndex: 1,
        totalCount: 0,
    };

    const DEFAULT_FILTERS = {
        monthYear: moment().format("YYYY-MM"),
        imceType: {},
        userRole: {},
        supervisors: [],
        scheduleSources: scheduleSourceList
    };

    let inputDataModel = { filterDate: "", BU: "", SupervisorRoles: "", SupervisorIds: "", pageIndex: 1, pageSize: 10, totalCount: 0, orderBy: "", sortBy: "" };
    let filters = structuredClone(DEFAULT_FILTERS);
    let pagination = structuredClone(DEFAULT_PAGINATION);
    let startDateofMonth = moment(filters.monthYear).startOf('month').format('YYYYMMDD');
    let endDateofMonth = moment(filters.monthYear).endOf('month').format('YYYYMMDD');

    let oldFilters = structuredClone(filters);

    let getAdmin = () => {
        adminList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        adminList.push({ ...e });
                    });
                    isAdmin = adminList.filter(x => x.code == 'Admin' && x.mapData == 1).length > 0 ? 1 : 0;
                    isSubsidiaryAdmin = adminList.filter(x => x.code == 'SubsidiaryAdmin' && x.mapData == 1).length > 0 ? 1 : 0;
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SummaryRptAdmin',
            }
        )
    }

    const getImceTypeList = () => {
        imceTypeList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    imceTypeList = result;
                    filters.imceType = imceTypeList.length > 0 ? imceTypeList[0] : {};
                    imceTypeOld = filters.imceType.code;
                    getDisplayPercentage();
                    getUserRoleList();
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: codeMasterType.bu,
            }
        )
    }

    let getUserRoleList = () => {
        userRoleList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        userRoleList.push({ ...e });
                    });
                    getUserRoleListByFilter();
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SupervisorRole',
            }
        )
    }

    let getUserRoleListByFilter = () => {
        userRoleListByFilter = [];
        if (userRoleList) {
            userRoleListByFilter = userRoleList.filter(x => x.mapData == filters.imceType.code);
            if (userRoleListByFilter.length > 0) {
                filters.userRole = userRoleListByFilter[0];
                if (initLoadData) {
                    getSupervisorList();
                } else {
                    getSupervisorListByFilter();
                }
            }
        } else {
            getUserRoleList();
        }
    }

    let getSupervisorList = () => {
        supervisorList = [];
        this.showLoading();
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        supervisorList.push({ ...e });
                    });
                }
                getSupervisorListByFilter();
                this.hideLoading();
            },
            (error) => {
                this.handleError(error);
                this.hideLoading();
            },
            {
                type: 'SupervisorOrLeadSupervisor',                
                mapData: userRoleList.map(i => i["code"]).join(',')
            }
        );
    }

    let getSupervisorListByFilter = () => {
        supervisorListByFilter = [];
        filters.supervisors = [];
        if (supervisorList) {
            supervisorListByFilter = supervisorList.filter(x => x.mapData == filters.userRole.code);
            if (initLoadData) {
                initLoadData = false;
                getSchedulePlanAndActualList();
            }
        } else {
            getSupervisorList();
        }
    }

    let getSchedulePlanAndActualList = () => {
        this.showLoading();
        scheduleModel.getSchedulePlanAndActualList(
            (result) => {
                tableData = result.data;

                pagination.pageIndex = result.pageIndex;
                pagination.pageSize = result.pageSize;
                pagination.totalCount = result.total;

                oldFilters = structuredClone(filters);
                this.hideLoading();
            },
            (error) => {
                this.handleError(error);
                this.hideLoading();
            },
            {
                filterDate: filters.monthYear.replace('-', ''),
                BU: filters.imceType.code,
                SupervisorIds: filters.supervisors.map(i => i["code"]).join(','),
                SupervisorRoles: filters.userRole.code,
                ScheduleSource: getScheduleSourceCode(),
                orderBy: 'USER_NM',
                sortBy: 'ASC',
                pageSize: pagination.pageSize,
                pageIndex: pagination.pageIndex,
            }
        )
    }
    function getScheduleSourceCode() {
        return filters.scheduleSources.length == scheduleSourceList.length ? "0" : (filters.scheduleSources.length > 0 ? filters.scheduleSources[0].code : "0")
    }

    let getDisplayPercentage = () => {
        userRoleList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        displayPercentageList.push({ ...e });
                    });
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SummaryDisplayPercentage',
                mapData: filters.imceType.code
            }
        )
    } 

    const onSearch = (e) => {
        startDateofMonth = moment(filters.monthYear).startOf('month').format('YYYYMMDD');
        endDateofMonth = moment(filters.monthYear).endOf('month').format('YYYYMMDD');
        search();
    }

    let onClear = () => {
        filters.monthYear = moment().format("YYYY-MM"),
        filters.userRole = userRoleListByFilter[0];
        filters.supervisors = [];
        scheduleSources = scheduleSourceList;
        pagination = structuredClone(DEFAULT_PAGINATION);
        search();
    }

    let search = () => {
        getSchedulePlanAndActualList();
    }

    const onPageChanged = (page) => {
        pagination.pageIndex = page;
        search();
    }
    const onPageSizeChanged = (page, size) => {
        pagination.pageIndex = page;
        pagination.pageSize = size;
        search();
    }

    const viewUnplannedStore = (userId) => {
        unplannedStoreUserId = userId;
        isDialogOpen = true;
    }

    const onDialogClose = () => {
        isDialogOpen = false;
    }

    let _downloadExcel = () => {
        this.showLoading();
        var fileName = uuidv4();

        if (oldFilters) {
            inputDataModel.filterDate = oldFilters.monthYear.replace('-', '');
            if (oldFilters.imceType.code != "")
                inputDataModel.BU = oldFilters.imceType.code;
            else
                inputDataModel.BU = "";
            if (oldFilters.supervisors.length > 0)
                inputDataModel.SupervisorIds = oldFilters.supervisors.map(i => i["code"]).join(',');
            else
                inputDataModel.SupervisorIds = "";
            inputDataModel.SupervisorRoles = oldFilters.userRole.code;
            inputDataModel.ScheduleSource = getScheduleSourceCode();
            inputDataModel.sortBy = "ASC";
            inputDataModel.orderBy = "USER_NM";
        }
        else {
            this.showErrorMessage(
                this.getText("", "Please select the filter."),
                this.getText("EM00000142", "Error")
            )
        }
        scheduleModel.jpoSummaryDownloadExcel(
            (result) => { this.hideLoading(); },
            (error) => {
                this.hideLoading();
                this.handleError(error);
            },
            inputDataModel, fileName
        )
    }
        
    function getCssClass(data) {
        for (let i = 0; i < displayPercentageList.length; i++) {
            const current = displayPercentageList[i];
            const ranges = current.code.split(",");
            for (let j = 0; j < ranges.length; j++) {
                const [min, max] = ranges[j].split("|").map((value) => parseInt(value));
                if (data >= min && data < max) {
                    if (i === 0) {
                        return "badge bg-success";
                    } else if (i === 1) {
                        return "badge bg-amber text-dark";
                    } else if (i === 2) {
                        return "badge jpo-bg-danger text-dark";
                    }
                }
            }
        }
    }
    
    const getTdElement = (data) => {
        let cssClass; 
        cssClass = getCssClass(data);
        return m('td', m('div', { "class": cssClass }, data),
        );
        
    }   

    const getLegend = () => {
        return m('.d-flex.align-items-center',
            
            m('div.jpo-number-line-container',
                m('div.jpo-number-line',
                    m('div.jpo-marker.start-point'),
                    m('div.jpo-highlighted-range.red-highlight', { style: 'left: calc(5.5%); width: calc(16%);' }),
                    m('div.jpo-marker.point.amber', { style: 'left: calc(24.9%);' }),
                    m('div.jpo-highlighted-range.amber-highlight', { style: 'left: calc(27.8%); width: calc(8%);' }),
                    m('div.jpo-marker.point.green', { style: 'left: calc(39.4%);' }),
                    m('div.jpo-highlighted-range.green-highlight', { style: 'left: calc(42.8%); width: calc(14%);' }),
                    m('div.jpo-marker.point.amber', { style: 'left: calc(60.3%);' }),
                    m('div.jpo-highlighted-range.amber-highlight', { style: 'left: calc(63.6%); width: calc(8%);' }),
                    m('div.jpo-marker.end-point', { style: 'left: calc(74.8%);' }),
                    m('div.jpo-highlighted-range.red-highlight', { style: 'left: calc(78.1%); width: calc(18%);' }),
                ),
                m('div.jpo-labels',
                    m('span.jpo-label.red', { style: 'left: 6px;' }, '0'),
                    m('span.jpo-label.amber', { style: 'left: calc(24.9%);' }, '80'),
                    m('span.jpo-label.green', { style: 'left: calc(39.4%);' }, '90'),
                    m('span.jpo-label.amber', { style: 'left: calc(60%);' }, '110'),
                    m('span.jpo-label.red', { style: 'left: calc(74.5%);' }, '120'),
                ),

            ),
        );
    };

    const getToolTipContent = (content) => {
        const arrContent = content.split('<br>');
        return m('div',
            arrContent.reduce((acc, item, index) => {
                acc.push(m('span', item));
                if (index < arrContent.length - 1) {
                    acc.push(m('br'));
                }
                return acc;
            }, [])
        );
    }

    const getTrigger = (trigger1, trigger2, trigger3) => {
        const triggers = [trigger1, trigger2, trigger3].filter(t => t != null);
        const cTrigger = triggers.flatMap((t, i) => [
            m('span', t),
            i < triggers.length - 1 ? m('br') : null
        ]);

        return m('div', cTrigger);
    }

    const getToolTips = (content, trigger1, trigger2, trigger3) => {
        return m(Tooltip, {
            content: getToolTipContent(content),
            hoverOpenDelay: 250,
            hoverCloseDelay: 250,
            openOnTriggerFocus: true,
            position: PopoverPosition.TOP,
            trigger: getTrigger(trigger1, trigger2, trigger3)
        })
    };

    const getLinkTd = (data,seq) => {
        const tdAttrs = {
            class: (data.typeCode == '1' || data.typeCode == '3') ? "sticky-col-total sticky-col-" + seq : "sticky-col sticky-col-" + seq
        };

        if (data.typeCode == '0' && data.storeIds != null) {
            tdAttrs.onclick = () => {
                m.route.set('/schedule/visit-rate', null, {
                    state: {
                        supervisorIDs: { 'userID': data.userId, 'userName': data.userName },
                        siteIDs: data.storeIds.split(","),
                        storeGrade: data.grade,
                        fromDate: startDateofMonth,
                        toDate: endDateofMonth,
                        bu: { 'code': oldFilters.imceType.code, 'name': oldFilters.imceType.name }
                    }
                });
            };
        }

        const spanAttrs = (data.typeCode == '0' && data.storeIds != null) ?
            { style: 'color: #0077C8; cursor: pointer;' } : {};

        return m('td', tdAttrs,
            m('span.cursor-text', spanAttrs, data.userName)
        );
        
    };

    const getStickyTd = (data, typeCode, seq) => {

        return m('td',
            //(typeCode == '1' || typeCode == '3') ? { "class": "sticky-col-total sticky-col-" + seq } : { "class": "sticky-col sticky-col-" + seq },
            (seq == '5') ,
            m('span.cursor-text', data));
    };

    const getUnPlanStickyTd = (data,seq) => {
        const tdAttrs = {
            //class: (data.typeCode == '1' || data.typeCode == '3') ? "sticky-col-total sticky-col-" + seq : "sticky-col sticky-col-" + seq
        };

        const tdChild = (data.typeCode == '1' || data.typeCode == '3') && data.assignStore > data.planVisitStore ?
            m('a.cursor-pointer.text-decoration-underline',
                { onclick: () => { viewUnplannedStore(data.userId) } }, data.assignStore
            )
            : m('span.cursor-text', data.assignStore);

        return m('td', tdAttrs, tdChild);
        
    };

    return {
        oninit: () => {
            initLoadData = true;
            getAdmin();
            getImceTypeList();
        },
        view: () => {
            return [
                // SEARCH
                m(".card.mb-3",
                    m(".card-body",
                        m(".row.mb-2.g-4",
                            m('.col-md-3',
                                m("label.form-label", this.getText("LT00000326", "Month")),
                                m("input.form-control.form-control-bg",
                                    {
                                        "type": "month",
                                        "value": filters.monthYear,
                                        onchange: (e) => {
                                            filters.monthYear = e.target.value;
                                        }
                                    }
                                ),
                            ),
                            m('.col-md-3',
                                m("label.form-label", this.getText("LT00000817", "MX/CE Store")),
                                m(SingleSelectComponent, {
                                    id: "imce",
                                    items: imceTypeList,
                                    selectedItem: filters.imceType,
                                    checkmark: true,
                                    filterable: true,
                                    required: true,
                                    allowEmpty: false,
                                    onSelect: (s) => {
                                        if (imceTypeOld != s.code && s.code != '') {
                                            filters.imceType = s;
                                            filters.userRole = userRoleListByFilter[0];
                                            filters.supervisors = [];
                                            getUserRoleListByFilter();
                                            imceTypeOld = s.code;
                                        }
                                    },
                                })
                            ),
                            m('.col-md-3',
                                m('label.form-label', this.getText("LT00000060", "User Role")),
                                m(SingleSelectComponent, {
                                    items: userRoleListByFilter,
                                    selectedItem: filters.userRole,
                                    allowEmpty: false,
                                    onSelect: (s) => {
                                        filters.userRole = s;
                                        getSupervisorListByFilter();
                                    }
                                }),
                            ),
                            m('.col-md-3',
                                m('label.form-label', this.getText(isSubsidiaryAdmin == 1 ? "LT00008108" : "LT00000271", isSubsidiaryAdmin == 1 ? "Lead Supervisor" : "Supervisor")),
                                m(MultiSelectComponent, {
                                    items: supervisorListByFilter,
                                    selectedItems: filters.supervisors,
                                    onSelect: (s) => {
                                        filters.supervisors = s;
                                    }
                                }),
                            ),
                        ),
                        m(".row.mb-2.g-4",                         
                            m('.col-md-3.col-lg-3.position-relative',
                                m('label.form-label', this.getText("LT00008161", "Schedule Source")),
                                m(MultiSelectComponent, {
                                    items: scheduleSourceList,
                                    selectedItems: filters.scheduleSources,
                                    onSelect: (s) => {
                                        filters.scheduleSources = s;      
                                    }
                                }),
                            ),                    
                            m(".col-xl-9.col-lg-6.d-flex.align-items-end.justify-content-end.gap-2",                  
                                m('button.btn.btn-primary',
                                    {
                                        onclick: () => {
                                            pagination = structuredClone(DEFAULT_PAGINATION);
                                            onSearch();
                                        },
                                    },
                                    this.getText("LT00000001", "Search")),

                                m('button.btn.btn-white', { onclick: onClear }, this.getText("LT00000031", "Clear")),
                            ),
                        ),
                    )
                ),
                // SEARCH - end

                // Table section
                m('.card',
                    m('.card-body',
                        m('.row.g-2 ',
                            m('.col-12.p-0',
                                m('.d-flex.justify-content-between.mb-2',
                                    getLegend(),

                                    m('a.btn.btn-primary', { onclick: _downloadExcel },
                                        m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                                    )
                                ),
                                m('.jpo-table-responsive',
                                    m('table.table.table-hover.align-middle',
                                        m('thead',
                                            m('tr.align-middle',
                                                m("th.jpo-border-left.sticky-col.sticky-col-1", { "scope": "col", "rowspan": "2" }, this.getText("LT00000271", "Supervisor")),
                                                m("th", { "scope": "col", "rowspan": "2" }, this.getText("LT00001177", "Grade")),
                                                m("th", { "scope": "col", "rowspan": "2" },
                                                    getToolTips(this.getText("LT00008128", "Number of Stores Assigned to Supervisor"),
                                                        this.getText("LT00000169", "Store"), this.getText("LT00008109", "(Assigned)"), null),
                                                ),
                                                m("th", { "scope": "col", "rowspan": "2" },
                                                    getToolTips(this.getText("LT00008129", "Number of Stores Plan Visit by JPO"),
                                                        this.getText("LT00000169", "Store"), this.getText("LT00008110", "(Plan)"), null),
                                                ),
                                                m("th", { "scope": "col", "rowspan": "2" },
                                                    getToolTips(this.getText("LT00008130", "Number of Stores Actual Visited including Unplanned Stores by Supervisor"),
                                                        this.getText("LT00000169", "Store"), this.getText("LT00008111", "(Actual)"), null),
                                                ),
                                                m("th.text-center", { "scope": "col", "colspan": "3" }, this.getText("LT00008100", "Visit Frequency (Total)")),
                                                m("th.text-center", { "scope": "col", "colspan": "3" }, this.getText("LT00008112", "Visit Frequency (Avg)")),
                                                m("th.text-center", { "scope": "col", "colspan": "3" }, this.getText("LT00008101", "Dwell Time (Avg)")),
                                                m("th.text-center", { "scope": "col", "colspan": "3" }, this.getText("LT00008102", "Travel Time (Avg)"))
                                            ),
                                            m("tr.text-center.light-header.thead-bggrey.align-middle", 
                                                m("th.text-end", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008131", "Number of Planned Visit Frequency by Store Grade in a Month"),
                                                        this.getText("LT00000283", "Target"), null, null),                                                    
                                                ),
                                                m("th.text-end", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008132", "Number of Actual Visited Frequency including Unplanned Stores by Store Grade in a Month"),
                                                        this.getText("LT00000284", "Actual"), null, null),                                                    
                                                ),
                                                m("th.text-center", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008133", "(Number of Actual Visited Frequency  / Number of Planned Visit Frequency) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),    
                                                ),

                                                m("th.text-end", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008134", "Number of Average Planned Visit Frequency by Store Grade in a Month"),
                                                        this.getText("LT00000283", "Target"), null, null),
                                                ),
                                                m("th.text-end", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008135", "Number of Average Actual Visited Frequency including Unplanned Stores by Store Grade in a Month"),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th.text-center", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008136", "(Number of Average Actual Visited Frequency  / Number of Average Planned Visit Frequency) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),

                                                m("th.text-end", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008137", "Average Planned Dwell Time by Store Grade "),
                                                        this.getText("LT00000283", "Target"), null, null),
                                                ),
                                                m("th.text-end", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008138", "Average Actual Dwell Time by Store Grade "),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th.text-center", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008139", "(Average Actual Dwell Time by Store Grade / Average Planned Dwell Time by Store Grade) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),

                                                m("th.text-end", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008140", "Average Planned Travelling Time by Store Grade "),
                                                        this.getText("LT00000283", "Target"), null, null),
                                                ),
                                                m("th.text-end", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008141", "Average Actual Travelling Time by Store Grade "),
                                                        this.getText("LT00000284", "Actual"), null, null),
                                                ),
                                                m("th.text-center", { "scope": "col" },
                                                    getToolTips(this.getText("LT00008142", "(Average Actual Travelling Time by Store Grade / Average Planned Travelling Time by Store Grade) * 100"),
                                                        this.getText("LT00008104", "(%)"), null, null),
                                                ),
                                            ),
                                        ),
                                        m('tbody',
                                            (tableData.length == 0) &&
                                            m('tr.align-middle',
                                                m('td[colSpan=17]', this.getText("EM00000141", "No records found."))
                                            ),
                                            tableData.length > 0 &&
                                            tableData.map((data, index) =>
                                                m('tr.align-middle',
                                                    data.typeCode == '1' || data.typeCode == '3' ? { "style": "background: lightgray" }
                                                        : {},                                                   
                                                    

                                                    getLinkTd(data, 1),
                                                    getStickyTd(data.grade, data.typeCode,2),
                                                    getUnPlanStickyTd(data, 3),
                                                    getStickyTd(data.planVisitStore, data.typeCode,4),
                                                    getStickyTd(data.actualVisitStore, data.typeCode,5),

                                                    

                                                    m('td.text-center', m('span.cursor-text', data.planVisitCount )),
                                                    m('td.text-center', m('span.cursor-text', data.actualVisitCount )),
                                                    m('td.text-center', m('span.cursor-text', data.actualVisitCountPct )),

                                                    //getTdElement(data.actualVisitCountPct, data.grade, data.typeCode, data.planVisitCount),

                                                    m('td.text-center', m('span.cursor-text', data.planVisitCountAvg )),
                                                    m('td.text-center', m('span.cursor-text', data.actualVisitCountAvg )),

                                                    getTdElement(data.actualVisitCountAvgPct, data.grade, data.typeCode, data.planVisitCount),

                                                    m('td.text-center', m('span.cursor-text', data.planDwellTimeAvg)),
                                                    m('td.text-center', m('span.cursor-text', data.actualDwellTimeAvg)),

                                                    getTdElement(data.actualDwellTimeAvgPct, data.grade, data.typeCode, data.planVisitCount),

                                                    m('td.text-center', m('span.cursor-text', data.planTravelingTimeAvg)),
                                                    m('td.text-center', m('span.cursor-text', data.actualTravelingTimeAvg)),

                                                    getTdElement(data.actualTravelingTimeAvgPct, data.grade, data.typeCode, data.planVisitCount),

                                                )
                                            )
                                        )
                                    ),
                                ),
                                tableData.length > 0 &&
                                m(".px-3",
                                    m(paginationComponent, {
                                        currentPage: pagination.pageIndex,
                                        pageSize: pagination.pageSize,
                                        totalItems: pagination.totalCount,
                                        onPageChanged: onPageChanged,
                                        onPageSizeChanged: onPageSizeChanged
                                    })
                                )
                            )
                        )
                    )
                ),
                // Table section - end
                isDialogOpen && m(UnplannedStoreDialog, {
                    inputFilterDate: oldFilters.monthYear.replace('-', ''),
                    inputBU: oldFilters.imceType.code,
                    inputSupervisorId: unplannedStoreUserId,
                    inputSupervisorIds: oldFilters.supervisors.map(item=>item['code']).join(','),
                    inputSupervisorRoles: oldFilters.userRole.code,
                    onClose: onDialogClose
                }),
                this.getBaseViews()
            ];
        }
    }
}